import './App.css';
import { useRoutes } from 'react-router-dom';
import ROUTER_LIST from './Route';
import Hoc from './Pages/Hoc/HocView';
import { Banner, NavigationView } from './Pages/Components';
import React from 'react';

const App = () => {
  const element = useRoutes(ROUTER_LIST);
  console.log(window.location.pathname);
  return (
    <div className="App">
      {window.location.pathname !== '/trial' && <NavigationView />}
      <Banner />
      {element}
    </div>
  );
};

export default Hoc(App);
